var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system"},[_c('side-nav',{attrs:{"menu-items":_vm.userInfo.menuItems}}),_c('div',{staticClass:"content",style:(`padding: ${_vm.noPadding ? '0' : '16px'}`)},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }